import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedStratalotPriceValueApiService } from './stratalot-price-value-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class StratalotPriceValueApiService extends GeneratedStratalotPriceValueApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
